import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  FormGroup,
  Validators,
  FormBuilder,
  FormControl,
  FormArray,
} from '@angular/forms';
import { LoadingController, ModalController, AlertController } from '@ionic/angular';
import { formatRFC3339, startOfDay } from 'date-fns';
import { get, isNumber, toString } from 'lodash';
import { BehaviorSubject, Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { unsubscriberHelper } from 'src/app/core/helpers/unsubscriber.helper';
import { GetCabinetSchedulesResponseModel } from 'src/app/core/models/getCabinetSchedules.response.model';
import { ProgrammareService } from 'src/app/core/services/programmare/programmare.service';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { IonRadioInputOption } from 'src/app/shared/models/components/ion-radio-input-option';
import { IonRadiosConfig } from 'src/app/shared/models/components/ion-radios-config';
import { IonTextItem } from 'src/app/shared/models/components/ion-text-item';

import { DictionaryService } from 'src/app/core/services/dictionary/dictionary.service';
import { IonInputConfig } from '@app/shared/models/components/ion-input-config';
import { LoadingControllerService } from '@app/core/services/loadingController/loading-controller.service';

@Component({
  selector: 'app-biz-searchable-counties-modal',
  templateUrl: './biz-searchable-counties-modal.component.html',
  styleUrls: ['./biz-searchable-counties-modal.component.scss'],
})
export class BizSearchableCountiesModalComponent implements OnInit, OnDestroy {

  @Input() config!: IonRadiosConfig;
  @Input() startTime: Date;
  @Input() endTime: Date;
  @Input() dayInAWeekWithDate: Array<Date>;
  @Input() @Input() set options(opts: Array<IonRadioInputOption>) {
    this.opts = opts ? opts : [];
    this.updateItems();
  }
  @Input() checkList!: any;
  @Input() locationUID: string;
  @Input() physicianUID: string;
  @Input() duration: number;
  @Input() selectedCabinetValue: string;
  @Input() allowCompettingApps: boolean;
  dictionary = this.dictionaryS.getDictionary();
  variant = this.dictionaryS.getVariant();
  isCabinetAvailable = false;
  getCabinets$: Subscription;
  getCabinetScheldules$: Subscription;
  getAppointments$: Subscription;
  list!: any;
  ionicForm: FormGroup;
  items$: BehaviorSubject<
  // SelectieServiciiChecklistModel
  Array<{
    first: any;
    second: string;
    third?: string;
    value: string | number;
  }>
> = new BehaviorSubject([]);

  isFormSubmitted = false;

  label: IonTextItem = {
    text: 'Default',
    classes: '',
    slot: 'end',
  };

  searchConfig: IonInputConfig = {
    placeholder: 'Caută',
    type: 'search',
    inputMode: 'search',
    size: 100,
    /* inputLabel: this.label, */
    clearable: false,
    inputClasses: '',
    minLength: 3,
    maxLength: 10,
    bgwhite: true,
    disabled: false,
    removeInputItemBaseLine: true,
    isInputFocused: false,
    debounce: 200,
    hidAssistiveText: true,
  };
  searchForm: FormGroup = this.fb.group({
    search: ['', [Validators.required]],
  });

  // items: Array<{
  //   id: any;
  //   label: string;
  //   disabledStatus: boolean;
  // }> = [];

  customRadioForm: FormGroup = this.fb.group({
    radio: ['', [Validators.required]],
  });
  cabinetOfEvent: GetCabinetSchedulesResponseModel[] = [];
  appointmentEndpointData$: BehaviorSubject<any> = new BehaviorSubject<any>({});
  cabinetScheldulesEndpointData$: BehaviorSubject<any> =
    new BehaviorSubject<any>([]);
  getPhysicianScheduleEndPointData$: BehaviorSubject<any> =
    new BehaviorSubject<any>([]);

  judetOption = [];

  public subscriptions = new Subscription();

  private opts: Array<IonRadioInputOption> = [];


  constructor(
    private fb: FormBuilder,
    private modalController: ModalController,
    private cdRef: ChangeDetectorRef,
    private loadingContollerS: LoadingControllerService,
    private toastService: ToastService,
    private programmareS$: ProgrammareService,
    private dictionaryS: DictionaryService,
    private alertController: AlertController
  ) { }

  ngOnInit(): void {
    //this.onLoadCheckboxStatus();
    // load check list to list
    this.subscriptions.add(
      this.searchForm.valueChanges
        .pipe(distinctUntilChanged())
        .subscribe((data) => {
          if (data.search !== '') {
            this.searching(data.search);
          } else {
            this.updateItems();
          }
        })
    );
  }



  // searching(st: string) {
  //   if (st) {
  //     //const d = this.items$.value.filter(
  //       const d = this.items.filter(
  //       (v: any) => v.label.toLowerCase().indexOf(st.toLowerCase()) > -1
  //     );
  //     if (d.length > 0) {
  //       //this.items.next(d);

  //       this.items =  d;
  //     } else {
  //       this.updateItems();
  //     }
  //   } else {
  //     this.updateItems();
  //   }
  // }

  searching(st: string) {
    if (st) {
      const d = this.items$.value.filter(
        (v: any) => v.second.toLowerCase().indexOf(st.toLowerCase()) > -1
      );
      if (d.length > 0) {
        this.items$.next(d);
      } else {
        this.updateItems();
      }
    } else {
      this.updateItems();
    }
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
      radioValue: this.controlValue ,
    },
      undefined,
      'BizSearchableCountiesModalComponent');
  }

  closeModal() {
    this.modalController.dismiss(
      {
        dismissed: true,
        radioValue: this.isCabinetAvailable ? this.controlValue : null,
      },
      undefined,
      'BizSearchableCountiesModalComponent'
    );
  }
  checkRadio(event: any) {
    this.toggleRadio(event?.detail?.value);
  }
  get controlI() {
    return this.customRadioForm.get('radio');
  }
  get controlValue() {
    return this.controlI ? this.controlI.value : null;
  }
  toggleRadio(data: any) {
    if (this.controlI.disabled) {
      return;
    }
    this.controlI.setValue(data);
    this.cdRef.markForCheck();
    this.dismiss();
  }
  // updateItems() {
  //   const labelK = get(this.config, 'labelKey', 'name');
  //   const idK = get(this.config, 'idKey', 'id');
  //   const disabledKey = get(this.config, 'disabledKey', 'disabledStatus');
  //   this.items =  this.opts
  //     .map((v) => ({
  //       id: get(v, idK, null),
  //       label: get(v, labelK, null),
  //       disabledStatus: get(v, disabledKey, null),
  //     }))
  //     .filter((vv) => get(vv, 'id', null) !== null);
  //   this.cdRef.markForCheck();
  // }

  updateItems() {
    const first = get(this.config, 'firstKey', 'id');
    const second = get(this.config, 'secondKey', 'name');
    const secondForCurrency = get(this.config, 'currencyKey', 'currency');
    const third = get(this.config, 'thirdKey', 'third');
    const value = get(this.config, 'idKey', 'value');
    const id = get(this.config, 'idKey', 'id');
    const items = this.opts
      .map((v) => {
        // make sure that the value is a string
        v[id] = isNumber(v[id]) ? toString(v[id]) : v[id];
        return {
          first: get(v, first, null),
          second: `${get(v, second, '')} ${get(v, secondForCurrency, '')}`,
          third: get(v, third, null),
          value: get(v, id, null) || get(v, value, null),
        };
      })
      .filter((vv) => get(vv, 'value', null) !== null);
    this.items$.next(items);
    this.cdRef.markForCheck();
    this.cdRef.detectChanges();
  }


  ngOnDestroy() {
    unsubscriberHelper(this.getCabinets$);
    unsubscriberHelper(this.getCabinetScheldules$);
    unsubscriberHelper(this.subscriptions);
  }
}
